import PropTypes from 'prop-types';
import React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid/dist/react-flexbox-grid';
import { FormattedMessage } from 'react-intl';
import Layout from '../../../../App/components/Layout/LayoutContainer';
import PricingPlans from './PricingPlans';
import { useParams } from 'react-router-dom';

import styles from './PricingPage.css';

const Pricing = () => {
  const { period } = useParams();
  return (
    <Layout>
      <Grid className={styles.mainGrid} fluid>
        <Row>
          <Col xs={12}>
            <h2>
              <FormattedMessage id="Pricing.Select" defaultMessage="Select plan" />
            </h2>
            <p>
              <FormattedMessage
                id="Pricing.ContactForCustomPlan"
                defaultMessage="If you don’t see a plan that meets your needs, please {contact}."
                values={{
                  contact: (
                    <a href="mailto:hello@promoter.ninja">
                      <FormattedMessage id="Pricing.ContactUs" defaultMessage="contact us" />
                    </a>
                  ),
                }}
              />
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={styles.pricingTable}>
              <PricingPlans period={period} />
            </div>
          </Col>
        </Row>
      </Grid>
    </Layout>
  );
};

export default Pricing;
